import { createFileRoute } from '@tanstack/react-router';

import CaseDetailPanel from '~/app/praetors/cases/CasesV2/CaseDetailPanel';

export const Route = createFileRoute('/_app/home/praetors/$praetorId/cases/$caseId')({
	beforeLoad: () => {
		return {
			getTitle: 'Details'
		};
	},
	component: function CaseDetail() {
		const { caseId } = Route.useParams();
		return <CaseDetailPanel caseId={caseId} />;
	}
});
